import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=2386b2eb&scoped=true"
import script from "./Dates.vue?vue&type=script&lang=js"
export * from "./Dates.vue?vue&type=script&lang=js"
import style0 from "./Dates.vue?vue&type=style&index=0&id=2386b2eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2386b2eb",
  null
  
)

export default component.exports